import { ACTIONS } from "./../constants"


const initialState = { 
  skillsEvaluationD2cFolders: [], 
  skillsEvaluationD2cFolder: {}, 
  totalSize: 0,
  isFetching: false, 
  isLoading: false,
  hasMore: true, 
  success: {
    isDeactivated: false,
    isCreated: false,
    isUpdated: false,
    isActivated: false,
  },
  error: null
}


export default (state = initialState , action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_SKILLS_EVALUATION_D2C : {
      return { ...state, success: initialState.success, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.FETCH_SKILLS_EVALUATIONS_D2C_INIT : {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.FETCH_SKILLS_EVALUATIONS_D2C_SUCCEDED : {
      const { count, results } = payload
      return { ...state, totalSize: count, skillsEvaluationD2cFolders: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_SKILLS_EVALUATIONS_D2C_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_SKILLS_EVALUATION_D2C_INIT : {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.CREATE_SKILLS_EVALUATION_D2C_SUCCEDED : {
      return { ...state, success: { ...state.success, isCreated: true }, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_SKILLS_EVALUATION_D2C_FAILED : {
      return { ...state, error: payload, isLoading: false }
    }

    case ACTIONS.EDIT_SKILLS_EVALUATION_D2C_INIT : {      
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.EDIT_SKILLS_EVALUATION_D2C_SUCCEDED : {
      return { ...state, skillsEvaluationD2cFolder: payload, success: { ...state.success, isUpdated: true }, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_SKILLS_EVALUATION_D2C_FAILED : {
      return { ...state, error: payload, isLoading: false }
    }
 
    case ACTIONS.FETCH_SKILLS_EVALUATION_D2C_INIT : {
      return { ...state, isLoading: true, skillsEvaluationD2cFolder: null, error: null }
    }
    case ACTIONS.FETCH_SKILLS_EVALUATION_D2C_SUCCEDED : {
      return { ...state, skillsEvaluationD2cFolder: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_SKILLS_EVALUATION_D2C_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.ACTIVATE_SKILLS_EVALUATION_D2C_INIT : {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.ACTIVATE_SKILLS_EVALUATION_D2C_SUCCEDED : {
      return { ...state, success: { ...state.success, isActivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.ACTIVATE_SKILLS_EVALUATION_D2C_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DEACTIVATE_SKILLS_EVALUATION_D2C_INIT: {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DEACTIVATE_SKILLS_EVALUATION_D2C_SUCCEDED: {
      return { ...state, success: { ...state.success, isDeactivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.DEACTIVATE_SKILLS_EVALUATION_D2C_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }

    default: {
      return state
    }
  }
}
